document.addEventListener('DOMContentLoaded', function () {
  let link;
  const hash = window.location.hash;
  switch (hash) {
    case '#login' :
      link = document.querySelector('[href$="/user/login"]');
      break;
    case '#register' :
      link = document.querySelector('[href$="/user/register"]');
      break;
    case '#edit-pass' :
      link = document.querySelector('[href$="/profile/change_pass"]');
      break;
  }
  if (link) {
    link.click();
    const urlWithoutHash = window.location.href.replace(hash, '');
    history.replaceState({}, '', urlWithoutHash);
  }
});
